<template>
  <div class="financial-statement-item">
    <col-table :data="financeData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <!-- <span class="tongbi">
              同比<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span> -->
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <!-- <span class="scale">同比</span> -->
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="endDate" label="报告截止日">
        <template slot-scope="scope">{{ scope.row.endDate }}</template>
      </col-table-column>
      <col-table-column prop="balanceSheetDate" label="年结日" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ scope.row.balanceSheetDate }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>盈利能力</template>
      </col-table-column>
      <col-table-column prop="grossProfitRate" label="毛利率">
        <template slot-scope="scope">{{ $digitjs(scope.row.grossProfitRate).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="netProfitRate" label="净利率">
        <template slot-scope="scope">{{ $digitjs(scope.row.netProfitRate).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="operatingProfitMargin" label="营业利润率">
        <template slot-scope="scope">{{ $digitjs(scope.row.operatingProfitMargin).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="ebitdaMargins" label="EBITDA利润率">
        <template slot-scope="scope">{{ $digitjs(scope.row.ebitdaMargins).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="rdExpenseratio" label="研发费用率">
        <template slot-scope="scope">{{ $digitjs(scope.row.rdExpenseratio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="marketingExpenseratio" label="销售费用率">
        <template slot-scope="scope">{{ $digitjs(scope.row.marketingExpenseratio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="managementExpenseratio" label="管理费用率">
        <template slot-scope="scope">{{ $digitjs(scope.row.managementExpenseratio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="roe" label="净资产收益率-摊薄">
        <template slot-scope="scope">{{ $digitjs(scope.row.roe).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="roa" label="总资产净利率">
        <template slot-scope="scope">{{ $digitjs(scope.row.roa).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="ebitMargins" label="息税前营业利润率" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row.ebitMargins).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>偿债能力</template>
      </col-table-column>
      <col-table-column prop="debtAssetRatio" label="资产负债率">
        <template slot-scope="scope">{{ $digitjs(scope.row.debtAssetRatio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="longtermDebtEquityRatio" label="长期负债股东权益比率">
        <template slot-scope="scope">{{ $digitjs(scope.row.longtermDebtEquityRatio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="equityMultiplier" label="权益乘数">
        <template slot-scope="scope">{{ $digitjs(scope.row.equityMultiplier).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="equityRatio" label="产权比率">
        <template slot-scope="scope">{{ $digitjs(scope.row.equityRatio).unit('%').rounded() }}</template>
      </col-table-column>
      <col-table-column prop="cr" label="流动比率">
        <template slot-scope="scope">{{ $digitjs(scope.row.cr).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="qr" label="速动比率">
        <template slot-scope="scope">{{ $digitjs(scope.row.qr).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="interestCoverageRatio" label="利息倍数" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row.interestCoverageRatio).rounded() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>营运能力</template>
      </col-table-column>
      <col-table-column prop="totalAssetsTurnover" label="总资产周转率(次)">
        <template slot-scope="scope">{{ $digitjs(scope.row.totalAssetsTurnover).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="totalAssetsTurnoverDays" label="总资产周转天数" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row.totalAssetsTurnoverDays).rounded() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>每股指标</template>
      </col-table-column>
      <col-table-column prop="eps" label="每股收益">
        <template slot-scope="scope">{{ $digitjs(scope.row.eps).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="epsTTM" label="每股收益TTM">
        <template slot-scope="scope">{{ $digitjs(scope.row.epsTTM).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="naps" label="每股净资产">
        <template slot-scope="scope">{{ $digitjs(scope.row.naps).rounded() }}</template>
      </col-table-column>
      <col-table-column prop="cfps" label="每股现金流">
        <template slot-scope="scope">{{ $digitjs(scope.row.cfps).rounded() }}</template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      financeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getIndicatorsStatement()
  },
  methods: {
    async getIndicatorsStatement() {
      const res = await this.$post(this.$api.f10.us + '/finance/key-indicator', {
        symbol: this.symbol,
        reportSize: 20,
        reportTypes: ['FY', 'Q4', 'Q9', 'Q3', 'Q6', 'Q2', 'Q1']
      })
      const reportTypeMap = {
        FY: 7,
        Q4: 6,
        Q9: 5,
        Q3: 4,
        Q6: 3,
        Q2: 2,
        Q1: 1
      }

      const data =
        res.data?.map((item) => {
          const { endDate, balanceSheetDate } = item
          const year = this.$dayjs(endDate).format('YYYY')
          const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
          item.sortYear = isBefore ? +year + 1 : +year
          return item
        }) ?? []
      this.financeData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>
